class LangChanger {
  constructor(elms) {
    this.dom = {elms: elms};
    this.dom.trigger = this.dom.elms;
    this.dom.button = document.querySelectorAll('[data-js="lang"] button');

    this.isMobile = false;
    this.isOpen = false;

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    [...this.dom.button].forEach((el) => {
      el.addEventListener('click', e => {
        if (!this.isMobile) { return }
        e.preventDefault();
        this.toggleMenu(e);
      });
    });

    [...this.dom.trigger].forEach((el)=>{
      el.addEventListener('mouseenter', e => {
        if (this.isMobile) { return }
        this.toggleMenuMouse(e);
      });
      el.addEventListener('mouseleave', e => {
        if (this.isMobile) { return }
        this.toggleMenuMouse(e);
      });
    })

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  toggleMenuMouse(e) {
    if (this.isOpen) {
      e.currentTarget.removeAttribute('data-state');
    } else {
      e.currentTarget.dataset.state = 'visibility:visible';
    }

    this.isOpen = !this.isOpen;
  }

  toggleMenu(e) {
    if (this.isOpen) {
      e.currentTarget.parentElement.removeAttribute('data-state');
    } else {
      e.currentTarget.parentElement.dataset.state = 'visibility:visible';
    }

    this.isOpen = !this.isOpen;
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      this.isMobile = true;
      return;
    } else {
      // console.log('pc');
      this.isMobile = false;
      return;
		}
	}
}

export default LangChanger
